<template>
  <div class="w-full flex flex-col p-1 border-box h-full">
    <section v-show='selectSpritesheet' class="grow overflow-auto">
      <h4 class="text-center text-lg text-gray-600 font-semibold">Choose Pack</h4>
      <apollo-spritesheet-gallery @select='onSelectSpritesheet' />
    </section>
    <section v-if='!selectSpritesheet' class="grow overflow-auto" :key='selectedSpritesheet'>
      <h4 class="text-center text-lg text-gray-600 font-semibold">Choose Image</h4>
      <view-spritesheet :spritesheet='selectedSpritesheet' @select='onSelectImage' />
    </section>

    <div class="h-12 w-full flex flex-none justify-center bg-white py-2 border-box border-t bg-gray-200">
      <pbc-button :disabled='selectSpritesheet' @click='back' >
        <arrow-left :size='24' />
        Back
      </pbc-button>

      <pbc-button :disabled='selectedImage === null' @click='onDone' >
        <check :size='24' />
        Done
      </pbc-button>

    </div>

  </div>
</template>
<script>
import ArrowLeft from '@icons/ArrowLeft.vue';
import Check from '@icons/Check.vue';
import ApolloSpritesheetGallery from './ApolloSpritesheetGallery.vue';
import ViewSpritesheet from '@/ui/molecules/ViewSpritesheet.vue';
export default {
  props:{
  },
  methods: {
    onSelectSpritesheet({id}) {
      console.log('select', id);
      this.selectSpritesheet = false;
      this.selectedSpritesheet = id;
    },
    onSelectImage({image, spritesheet}) {
      console.log('1 select', image, spritesheet);
      this.selectedImage = {
        image,
        spritesheet
      }
      this.$emit("select", {image, spritesheet});
    },
    back() {
      this.selectedImage = null;
      this.selectSpritesheet = true;
    },
    onDone() {
      this.$emit("select", this.selectedImage);
    }
  },
  data() {
    return {
      selectSpritesheet: true,
      selectedSpritesheet: '',
      selectedImage:null
    }
  },
  components: {
    ApolloSpritesheetGallery,
    ViewSpritesheet,
    ArrowLeft,
    Check
  }
}
</script>
